import { RootAppState } from '../types';

export const getPopupVisibility = (state: RootAppState) => state.popup.isExpanded;

export const getPopupSettings = (state: RootAppState) => state.popup.settings;
